export default __webpack_public_path__ + "static/media/correct.4922b1d6.svg";